import React from 'react';
import PropTypes from 'prop-types';

import get from 'utils/get';
import cx from 'classnames';
import slugify from 'utils/slugify';
import imageModel from 'models/imageModel';
import flattenMediaData from 'utils/flattenMediaData';
import marked from 'marked';

import { Video } from 'components/base';

const BlockVideo = ({ block }) => {
  const fields = get(block, 'fields', {});
  const title = get(fields, 'title', '');
  const paddingTop = slugify(get(fields, 'paddingTop', 'Large'));
  const paddingBottom = slugify(get(fields, 'paddingBottom', 'Large'));
  const video = flattenMediaData(get(fields, 'video', {}));
  const showBlockTitle = get(fields, 'showBlockTitle', false);
  const text = get(fields, 'text', '');
  const textWidthSmall = get(fields, 'textWidthSmall', false);
  const textAlign = slugify(get(block, 'textAlign', 'Start'));

  return (
    <div
      className={cx(
        `BlockVideo relative padding-top-${paddingTop} padding-bottom-${paddingBottom} block-width mxauto flex flex-col items-center justify-center`,
        { guideline: showBlockTitle }
      )}
    >
      {showBlockTitle ? (
        <p className="block-title absolute r0 t0">{title}</p>
      ) : null}
      <div className="image-width-wide-medium w100">
        <Video className="w100" controls={true} src={video.url} muted={false} />
      </div>
      <div
        className={cx('BlockVideo__text-container w100 px2_5 flex flex-col', {
          'items-start': textAlign === 'start',
          'items-center': textAlign === 'center',
          'items-end': textAlign === 'end'
        })}
      >
        {!!text && (
          <div
            className={cx('caption caption-text-width markdown-text my1', {
              'caption-text-width-small': textWidthSmall
            })}
            dangerouslySetInnerHTML={{
              __html: marked(text)
            }}
          />
        )}
      </div>
    </div>
  );
};

BlockVideo.propTypes = {
  block: PropTypes.shape({
    fields: PropTypes.shape({
      title: PropTypes.string,
      video: imageModel.propTypes,
      paddingBottom: PropTypes.string,
      paddingTop: PropTypes.string,
      showBlockTitle: PropTypes.bool,
      textWidthSmall: PropTypes.bool,
      textAlign: PropTypes.string,
      text: PropTypes.string
    })
  })
};

BlockVideo.defaultProps = {
  block: {
    fields: {
      title: '',
      video: imageModel.default,
      paddingTop: 'Large',
      paddingBottom: 'Large',
      showBlockTitle: false,
      textWidthSmall: false,
      textAlign: 'Start',
      text: ''
    }
  }
};

export default BlockVideo;
